import Maxio from './chargify';

window.Maxio = Maxio;
